export default __webpack_public_path__ + "static/media/import_guidlines2.cba8dbda.png";